import { useCampaignsShow } from '@jobilla/nexus-sdk'
import { BakedInCampaignFeedAd, BakedInCampaignStoryAd } from '../../ui'

type CampaignPreviewsHelpers = {
	bakedInFeedAd: BakedInCampaignFeedAd
	bakedInStoryAd: BakedInCampaignStoryAd
	isLoading: boolean
}

export function useCampaignPreviews(campaignId: string): CampaignPreviewsHelpers {
	const campaignDetails = useCampaignsShow(campaignId)

	return {
		bakedInFeedAd: {
			primaryText: campaignDetails.data?.feed?.metaPrimaryText ?? '',
			headlineText: campaignDetails.data?.feed?.metaTitle ?? '',
			descriptionText: campaignDetails.data?.feed?.metaDescription ?? '',
			metaCtaText: campaignDetails.data?.feed?.metaCallToAction ?? '',
			bakedInImage: campaignDetails.data?.image ?? '',
		},
		bakedInStoryAd: {
			bakedInImage: campaignDetails.data?.storyImage ?? '',
		},
		isLoading: campaignDetails.isLoading,
	}
}
